import * as COM from '../components';
const marketingMgr = [
  /** ------------------------------ 积分商城 ------------------------------ */
  {
    path: '/integral-mall',
    component: COM.Layout,
    redirect: '/integral-mall/exchange-list',
    name: 'market__integralParadise',
    meta: { label: '积分商城' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 积分兑换列表
      {
        path: '/integral-mall/exchange-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralExchangeList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralExchangeList',
        meta: { label: '兑换列表', icon: 'el-icon-document', menuKeyPath: '/integral-mall/exchange-list' }
      },
      {
        path: '/integral-mall/exchange-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/integral-mall/exchange-list',
        name: 'integralExchangeListLayout',
        meta: { label: '兑换列表', insidePageFrom: 'integralExchangeList' },
        children: [
          // 新建兑换商品
          {
            path: '/integral-mall/exchange-list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.IntegralExchangeAdd,
            },
            name: 'integralExchangeAdd',
            meta: { label: '新建兑换商品', icon: 'el-icon-document', menuKeyPath: '/integral-mall/exchange-list', authKey: '#integralExchangeList.add' },
          },
          // 编辑兑换商品
          {
            path: '/integral-mall/exchange-list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.IntegralExchangeAdd,
            },
            name: 'integralExchangeEdit',
            meta: { label: '编辑兑换商品', icon: 'el-icon-document', menuKeyPath: '/integral-mall/exchange-list', authKey: '#integralExchangeList.modify' }
          },
          // 兑换商品详情
          {
            path: '/integral-mall/exchange-list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.IntegralExchangeDetail,
            },
            name: 'integralExchangeDetail',
            meta: { label: '兑换商品详情', icon: 'el-icon-document', menuKeyPath: '/integral-mall/exchange-list', authKey: 'integralExchangeList' }
          },
        ]
      },
      // 订单管理
      {
        path: '/integral-mall/order-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.OrderList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'orderList',
        meta: { label: '订单管理', icon: 'el-icon-document', menuKeyPath: '/integral-mall/order-list' }
      },
      {
        path: '/integral-mall/order-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/integral-mall/order-list/detail',
        name: 'orderListLayout',
        meta: { label: '订单管理', insidePageFrom: 'orderList' },
        children: [
          // 订单详情
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.OrderListDetail,
            },
            name: 'orderListDetail',
            meta: { label: '订单详情', icon: 'el-icon-document', menuKeyPath: '/integral-mall/order-list', authKey: 'orderList' }
          }
        ]
      },
      // 商城积分管理
      {
        path: '/integral-mall/integralMall',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralMall,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralMall',
        meta: { label: '商城积分管理', icon: 'el-icon-document', menuKeyPath: '/integral-mall/integralMall' }
      }
    ]
  },
  /** ------------------------------ 推广工具 ------------------------------ */
  {
    path: '/marketing-tools',
    component: COM.Layout,
    redirect: '/marketing-tools/adList',
    name: 'market__marketingTool',
    meta: { label: '推广工具' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 广告管理
      {
        path: 'adList',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AdList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'adList',
        meta: { label: '广告管理', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/adList' }
      },
      {
        path: '/marketing-tools/adList',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/marketing-tools/adList',
        name: 'adListLayout',
        meta: { label: '广告管理', insidePageFrom: 'adList' },
        children: [
          // 广告详情
          {
            path: '/marketing-tools/adDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AdDetail,
            },
            name: 'adDetail',
            meta: { label: '广告位数据', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/adList', authKey: 'adList' }
          },
        ]
      },
      // 短链管理
      {
        path: 'short-chain',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.ShortChainList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'shortChainList',
        meta: { label: '短链管理', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/short-chain' }
      },
      {
        path: '/marketing-tools/short-chain',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/marketing-tools/short-chain',
        name: 'shortChainListLayout',
        meta: { label: '短链管理', insidePageFrom: 'shortChainList' },
        children: [
          {
            path: '/marketing-tools/short-chain/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ShortChainAdd,
            },
            name: 'shortChainAdd',
            meta: { label: '新建短链', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/short-chain', authKey: '#shortChainList.add' }
          },
          {
            path: '/marketing-tools/short-chain/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ShortChainAdd,
            },
            name: 'shortChainEdit',
            meta: { label: '短链配置', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/short-chain', authKey: '#shortChainList.modify' }
          },
          {
            path: '/marketing-tools/short-chain/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ShortChainDetail,
            },
            name: 'shortChainDetail',
            meta: { label: '短链详情', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/short-chain', authKey: 'shortChainList' }
          },
        ]
      },
      // 短信列表
      {
        path: 'sms',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.SmsManagementList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'smsManagementList',
        meta: { label: '短信列表', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms' }
      },
      {
        path: '/marketing-tools/sms',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/marketing-tools/sms',
        name: 'smsLayout',
        meta: { label: '短信列表', insidePageFrom: 'smsManagementList' },
        children: [
          // 新建上传短信
          {
            path: '/marketing-tools/sms/add-batch',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsAddBatch,
            },
            name: 'smsAddBatch',
            meta: { label: '新建上传短信', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#smsManagementList.add' }
          },
          // 新建精准营销短信
          {
            path: '/marketing-tools/sms/add-point',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsAddPoint,
            },
            name: 'smsAddPoint',
            meta: { label: '新建精准短信', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#smsManagementList.add' }
          },
          // 编辑上传短信
          {
            path: '/marketing-tools/sms/edit-batch',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsAddBatch,
            },
            name: 'smsEditBatch',
            meta: { label: '编辑上传短信', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#smsManagementList.modify' }
          },
          // 编辑精准营销短信
          {
            path: '/marketing-tools/sms/edit-point',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsAddPoint,
            },
            name: 'smsEditPoint',
            meta: { label: '编辑精准短信', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#smsManagementList.modify' }
          },
          // 详情
          {
            path: '/marketing-tools/sms/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsDetail,
            },
            name: 'smsDetail',
            meta: { label: '发送详情', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: 'smsManagementList' }
          },
          // 短信模板
          {
            path: '/marketing-tools/sms-template',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsTemplateList,
            },
            name: 'smsTemplateList',
            meta: { label: '短信模板', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms' }
          }
        ]
      },
      {
        path: '/marketing-tools/sms-template',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/marketing-tools/sms-template',
        name: 'smsTemplateListLayer',
        meta: { label: '短信模板', insidePageFrom: 'smsManagementList' },
        children: [
          // 新建短信模板
          {
            path: '/marketing-tools/sms-template/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsAddTemplate,
            },
            name: 'smsAddTemplate',
            meta: { label: '新建短信模板', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#_smsTemplateList.add' }
          },
          // 编辑短信模板
          {
            path: '/marketing-tools/sms-template/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsAddTemplate,
            },
            name: 'smsEditTemplate',
            meta: { label: '编辑短信模板', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#_smsTemplateList.edit' }
          },
          // 模板详情
          {
            path: '/marketing-tools/sms-template/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SmsTemplateDetail,
            },
            name: 'smsTemplateDetail',
            meta: { label: '模板详情', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/sms', authKey: '#_smsTemplateList.detail' }
          }
        ]
      },
      // 消息管理
      {
        path: 'msgList',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MsgManagementList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'msgManagementList',
        meta: { label: '消息管理', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/msgList' }
      },
      {
        path: '/marketing-tools/msgList',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/marketing-tools/msgList',
        name: 'msgLayout',
        meta: { label: '消息管理', insidePageFrom: 'msgManagementList' },
        children: [
          // 新建消息
          {
            path: '/marketing-tools/msgCreate',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MsgCreate,
            },
            name: 'msgCreate',
            meta: { label: '新建消息', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/msgList', authKey: '#msgManagementList.add' }
          },
          // 编辑消息
          {
            path: '/marketing-tools/msgEdit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MsgCreate,
            },
            name: 'msgEdit',
            meta: { label: '编辑消息', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/msgList', authKey: '#msgManagementList.modify' }
          },
          // 消息详情
          {
            path: '/marketing-tools/msgDetail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MsgDetail,
            },
            name: 'msgDetail',
            meta: { label: '消息详情', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/msgList', authKey: 'msgManagementList' }
          }
        ]
      },
      // 微信模板消息
      {
        path: 'wechat-template-msg',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.WechatTemplateMsg,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'wechatTemplateMsg',
        meta: { label: '微信模板消息', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/wechat-template-msg' }
      },
      // 内容管理列表
      {
        path: '/marketing-tools/content-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.ContentList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'contentList',
        meta: { label: '内容短链管理', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/content-list' }
      },
      // 内容管理详情
      {
        path: '/marketing-tools/content-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/marketing-tools/content-list/add',
        name: 'contentListLayout',
        meta: { label: '内容短链管理', insidePageFrom: 'contentList' },
        children: [
          // 内容详情
          {
            path: '/marketing-tools/content-list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ContentAdd
            },
            name: 'contentAdd',
            meta: { label: '内容详情', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/content-list', authKey: '' }
          },
          // 内容效果
          {
            path: '/marketing-tools/content-list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.ContentDetail
            },
            name: 'contentDetail',
            meta: { label: '内容效果', icon: 'el-icon-document', menuKeyPath: '/marketing-tools/content-list', authKey: '' }
          }
        ]
      }
    ]
  },
  /** ------------------------------ 运营管理 ------------------------------ */
  {
    path: '/operation',
    component: COM.Layout,
    redirect: '/operation/pushManage',
    name: 'market__operationManage',
    meta: { label: '运营管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 推送管理
      {
        path: 'pushManage',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.pushManage,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'pushManage',
        meta: { label: '推送管理', icon: 'el-icon-document', menuKeyPath: '/operation/pushManage' }
      },
      {
        path: '/operation/pushManage',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/operation/pushManage/add',
        name: 'pushManageLayout',
        meta: { label: '推送管理', insidePageFrom: 'pushManage' },
        children: [
          // 新增推送
          {
            path: '/operation/pushManage/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.pushManageAdd
            },
            name: 'pushManageAdd',
            meta: { label: '新增推送', icon: 'el-icon-document', menuKeyPath: '/operation/pushManage', authKey: '#pushManage.add' }
          },
          // 编辑推送
          {
            path: '/operation/pushManage/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.pushManageEdit
            },
            name: 'pushManageEdit',
            meta: { label: '编辑推送', icon: 'el-icon-document', menuKeyPath: '/operation/pushManage', authKey: '#pushManage.modify' }
          },
          // 推送详情
          {
            path: '/operation/pushManage/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.pushManageDetail
            },
            name: 'pushManageDetail',
            meta: {
              label: '推送详情',
              icon: 'el-icon-document',
              menuKeyPath: '/operation/pushManage',
              authKey: 'pushManage'
            }
          },
        ]
      },
      // 推送分析
      {
        path: 'pushAnalysis',
        icon: 'el-icon-document',
        components: {
          webView: COM.pushAnalysis,
          appHeader: COM.NavHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'pushAnalysis',
        meta: { label: '推送分析', icon: 'el-icon-document', menuKeyPath: '/operation/pushAnalysis' }
      },
      // 广告任务管理
      // {
      //   path: 'advertisementManage',
      //   icon: 'el-icon-document',
      //   components: {
      //     bodyView: COM.advertisementManage,
      //     appHeader: COM.NavHeader,
      //     bodyHeader: COM.BodyHeader,
      //     secondMenu: COM.SecondMenu
      //   },
      //   name: 'advertisementManage',
      //   meta: { label: '广告任务管理', icon: 'el-icon-document', menuKeyPath: '/operation/advertisementManage' }
      // },
      // {
      //   path: '/operation/advertisementManage',
      //   icon: 'el-icon-document',
      //   components: {
      //     bodyView: COM.DetailLayout,
      //     appHeader: COM.NavHeader,
      //     bodyHeader: COM.BodyHeader,
      //     secondMenu: COM.SecondMenu
      //   },
      //   redirect: '/operation/advertisementManage/advAdd',
      //   name: 'advertisementManageLayout',
      //   meta: { label: '广告任务管理', insidePageFrom: 'advertisementManage' },
      //   children: [
      //     // 新增广告
      //     {
      //       path: '/operation/advertisementManage/advAdd',
      //       icon: 'el-icon-document',
      //       components: {
      //         bodyView: COM.advAdd
      //       },
      //       name: 'advAdd',
      //       meta: { label: '新增广告', icon: 'el-icon-document', menuKeyPath: '/operation/advertisementManage', authKey: '#advertisementManage.add' }
      //     },
      //     // 编辑广告
      //     {
      //       path: '/operation/advertisementManage/advEdit/:Id',
      //       icon: 'el-icon-document',
      //       components: {
      //         bodyView: COM.advEdit
      //       },
      //       name: 'advEdit',
      //       meta: { label: '编辑广告', icon: 'el-icon-document', menuKeyPath: '/operation/advertisementManage', authKey: '#advertisementManage.modify' }
      //     },
      //     // 广告详情
      //     {
      //       path: '/operation/advertisementManage/advDetail/:Id',
      //       icon: 'el-icon-document',
      //       components: {
      //         bodyView: COM.advDetail
      //       },
      //       name: 'advDetail',
      //       meta: { label: '广告详情', icon: 'el-icon-document', menuKeyPath: '/operation/advertisementManage', authKey: 'advertisementManage' }
      //     },
      //   ]
      // },
      {
        path: 'advManagementNew',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AdList1,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'advManagementNew',
        meta: { label: '广告任务管理', icon: 'el-icon-document', menuKeyPath: '/operation/advManagementNew' }
      },
      {
        path: '/operation/advManagementNew',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/operation/advManagementNew',
        name: 'advManagementNewLayout',
        meta: { label: '广告任务管理', insidePageFrom: 'advManagementNew' },
        children: [
          // 广告详情
          {
            path: '/operation/adKanban/:touchPositionId/:sourceSystem',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.adKanban
            },
            name: 'adKanban',
            meta: { label: '广告详情', icon: 'el-icon-document', menuKeyPath: '/operation/advManagementNew', authKey: 'advManagementNew' }
          },
        ]
      },
      // 广告分析
      {
        path: 'advertisementAnalysis',
        icon: 'el-icon-document',
        components: {
          webView: COM.advertisementAnalysis,
          appHeader: COM.NavHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'advertisementAnalysis',
        meta: {
          label: '广告分析',
          icon: 'el-icon-document',
          menuKeyPath: '/operation/advertisementAnalysis'
        }
      },
      // 广告位管理
      {
        path: 'advPosManage',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.advPosManage,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'advPosManage',
        meta: { label: '广告位管理', icon: 'el-icon-document', menuKeyPath: '/operation/advPosManage' }
      },
      {
        path: '/operation/advPosManage',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/operation/advPosManage/advPosAdd',
        name: 'advPosManageLayout',
        meta: { label: '广告位管理', insidePageFrom: 'advPosManage' },
        children: [
          // 新增广告位
          {
            path: '/operation/advPosManage/advPosAdd',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.advPosAdd
            },
            name: 'advPosAdd',
            meta: { label: '新增广告位', icon: 'el-icon-document', menuKeyPath: '/operation/advPosManage', authKey: '#advPosManage.add' }
          },
          // 编辑广告位
          {
            path: '/operation/advPosManage/advPosEdit/:Id/:sourceSystem',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.advPosEdit
            },
            name: 'advPosEdit',
            meta: { label: '编辑广告位', icon: 'el-icon-document', menuKeyPath: '/operation/advPosManage', authKey: '#advPosManage.modify' }
          }
        ]
      },
      // 页面管理
      {
        path: 'pageManage',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.pageManage,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'pageManage',
        meta: { label: '页面管理', icon: 'el-icon-document', menuKeyPath: '/operation/pageManage' }
      },
      {
        path: '/operation/pageManage',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/operation/pageManage/pageAdd',
        name: 'pageManageLayout',
        meta: { label: '页面管理', insidePageFrom: 'pageManage' },
        children: [
          // 新增页面
          {
            path: '/operation/pageManage/pageAdd',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.pageAdd
            },
            name: 'pageAdd',
            meta: { label: '页面编辑', icon: 'el-icon-document', menuKeyPath: '/operation/pageManage', authKey: '#pageManage.add' }
          },
          // 查看页面
          {
            path: '/operation/pageManage/pageSnapshot',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.pageAdd
            },
            name: 'pageSnapshot',
            meta: { label: '发布中页面', icon: 'el-icon-document', menuKeyPath: '/operation/pageManage', authKey: 'pageManage' }
          },
        ]
      },
      // 页面分析
      {
        path: 'pageAnalysis',
        icon: 'el-icon-document',
        components: {
          webView: COM.pageAnalysis,
          appHeader: COM.NavHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'pageAnalysis',
        meta: { label: '页面分析', icon: 'el-icon-document', menuKeyPath: '/operation/pageAnalysis' }
      },
    ]
  },
  /** ------------------------------ 活动中心 ------------------------------ */
  {
    path: '/activity-center',
    component: COM.Layout,
    redirect: '/activity-center/sign',
    name: 'market__activityCenter',
    meta: { label: '活动中心' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 签到活动
      {
        path: 'sign',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.SignList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'activityCenterList',
        meta: { label: '签到活动', icon: 'el-icon-document', menuKeyPath: '/activity-center/sign' }
      },
      {
        path: '/activity-center/sign',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/activity-center/sign/add',
        name: 'activityCenterLayout',
        meta: { label: '签到活动', insidePageFrom: 'activityCenterList' },
        children: [
          // 新增签到活动
          {
            path: '/activity-center/sign/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SignAdd
            },
            name: 'signAdd',
            meta: { label: '新增签到活动', icon: 'el-icon-document', menuKeyPath: '/activity-center/sign', authKey: '#activityCenterList.add' }
          },
          // 编辑签到活动
          {
            path: '/activity-center/sign/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.SignAdd
            },
            name: 'signEdit',
            meta: { label: '编辑签到活动', icon: 'el-icon-document', menuKeyPath: '/activity-center/sign', authKey: '#activityCenterList.modify' }
          }
        ]
      }
    ]
  },
  /** ------------------------------ 新品试用 ------------------------------ */
  {
    path: '/trial-products',
    component: COM.Layout,
    redirect: '/trial-products/list',
    name: 'market__trialProducts',
    meta: { label: '新品试用' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 新品试用列表
      {
        path: 'list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.TrialList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'trialList',
        meta: { label: '新品试用', icon: 'el-icon-document', menuKeyPath: '/trial-products/list' }
      },
      // 新增新品试用
      {
        path: '/trial-products/list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/trial-products/list/add',
        name: 'trialListLayout',
        meta: { label: '新品试用', insidePageFrom: 'trialList' },
        children: [
          // 新建新品试用活动
          {
            path: '/trial-products/list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TrialAdd
            },
            name: 'trialAdd',
            meta: { label: '新建新品试用活动', icon: 'el-icon-document', menuKeyPath: '/trial-products/list', authKey: '#trialList.add' }
          },
          // 编辑新品试用活动
          {
            path: '/trial-products/list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TrialAdd
            },
            name: 'trialEdit',
            meta: { label: '编辑新品试用活动', icon: 'el-icon-document', menuKeyPath: '/trial-products/list', authKey: '#trialList.modify' }
          },
          // 新品试用详情页
          {
            path: '/trial-products/list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TrialDetail
            },
            name: 'trialDetail',
            meta: { label: '新品试用详情页', icon: 'el-icon-document', menuKeyPath: '/trial-products/list', authKey: 'trialList' }
          },
        ]
      },
      // 用户试用列表
      {
        path: 'user-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.UserTrialList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'userTrialList',
        meta: { label: '用户试用列表', icon: 'el-icon-document', menuKeyPath: '/trial-products/user-list' }
      },
      // 编辑评测内容
      {
        path: '/trial-products/user-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/trial-products/user-list/edit-evaluate',
        name: 'userTrialListLayout',
        meta: { label: '用户试用列表', insidePageFrom: 'userTrialList' },
        children: [
          // 编辑评测内容
          {
            path: 'edit-evaluate',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.EditEvaluate
            },
            name: 'editEvaluate',
            meta: { label: '编辑评测', icon: 'el-icon-document', menuKeyPath: '/trial-products/user-list', authKey: '#userTrialList.modify' }
          }
        ]
      },
      // 评测内容列表
      {
        path: 'evaluation-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.EvaluationList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'evaluationList',
        meta: { label: '评测内容列表', icon: 'el-icon-document', menuKeyPath: '/trial-products/evaluation-list' }
      },
      // 评测内容列表 - 新增编辑
      {
        path: '/trial-products/evaluation-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/trial-products/evaluation-list/add',
        name: 'evaluationListLayout',
        meta: { label: '评测内容列表', insidePageFrom: 'evaluationList' },
        children: [
          // 新增评测内容
          {
            path: 'add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.EditEvaluate
            },
            name: 'evaluateAdd',
            meta: { label: '新增评测', icon: 'el-icon-document', menuKeyPath: '/trial-products/evaluation-list', authKey: '#evaluationList.add' }
          },
          // 编辑评测内容
          {
            path: 'edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.EditEvaluate
            },
            name: 'evaluateEdit',
            meta: { label: '编辑评测', icon: 'el-icon-document', menuKeyPath: '/trial-products/evaluation-list', authKey: '#evaluationList.modify' }
          },
          // 新增评测内容
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.EvaluationDetail
            },
            name: 'evaluationDetail',
            meta: { label: '评测内容详情', icon: 'el-icon-document', menuKeyPath: '/trial-products/evaluation-list', authKey: 'evaluationList' }
          }
        ]
      }
    ]
  },
  /** ------------------------------ 优惠券管理 ------------------------------ */
  {
    path: '/coupon-center',
    component: COM.Layout,
    redirect: '/coupon-center/coupon-rule-list',
    name: 'market__couponCenter',
    meta: { label: '优惠券管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 优惠券规则
      {
        path: '/coupon-center/coupon-rule-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.CouponRuleList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'couponRuleList',
        meta: { label: '优惠券规则', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-rule-list' }
      },
      {
        path: '/coupon-center/coupon-rule-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/coupon-center/coupon-rule-list',
        name: 'couponRuleListLayout',
        meta: { label: '优惠券规则', insidePageFrom: 'couponRuleList' },
        children: [
          // 新建优惠券规则
          {
            path: '/coupon-center/coupon-rule-list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponRuleAdd,
            },
            name: 'couponRuleAdd',
            meta: { label: '新建优惠券规则', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-rule-list', authKey: '#couponRuleList.add' },
          },
          // 编辑优惠券规则
          {
            path: '/coupon-center/coupon-rule-list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponRuleAdd,
            },
            name: 'couponRuleEdit',
            meta: { label: '编辑优惠券规则', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-rule-list', authKey: '#couponRuleList.modify' }
          },
          // 优惠券规则详情
          {
            path: '/coupon-center/coupon-rule-list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponRuleDetail,
            },
            name: 'couponRuleDetail',
            meta: { label: '优惠券规则详情', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-rule-list', authKey: 'couponRuleList' }
          },
        ]
      },
      // 手动领取列表
      {
        path: '/coupon-center/coupon-manual-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.CouponManualList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'couponManualList',
        meta: { label: '手动领取列表', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-manual-list' }
      },
      {
        path: '/coupon-center/coupon-manual-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/coupon-center/coupon-manual-list',
        name: 'couponManualListLayout',
        meta: { label: '手动领取列表', insidePageFrom: 'couponManualList' },
        children: [
          // 新建手动领取
          {
            path: '/coupon-center/coupon-manual-list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponManualAdd,
            },
            name: 'couponManualAdd',
            meta: { label: '新建手动领取', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-manual-list', authKey: '#couponManualList.add' },
          },
          // 编辑手动领取
          {
            path: '/coupon-center/coupon-manual-list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponManualAdd,
            },
            name: 'couponManualEdit',
            meta: { label: '编辑手动领取', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-manual-list', authKey: '#couponManualList.modify' }
          },
          // 手动领取详情
          {
            path: '/coupon-center/coupon-manual-list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponManualDetail,
            },
            name: 'couponManualDetail',
            meta: { label: '手动领取详情', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-manual-list/detail', authKey: 'couponManualList' }
          },
        ]
      },
      // 自动领取列表-colmo独有
      {
        path: '/coupon-center/coupon-auto-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.CouponAutoList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'couponAutoList',
        meta: { label: '自动领取列表', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-auto-list' }
      },
      {
        path: '/coupon-center/coupon-auto-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/coupon-center/coupon-auto-list',
        name: 'couponAutoListLayout',
        meta: { label: '自动领取列表', insidePageFrom: 'couponAutoList' },
        children: [
          // 新建自动领取
          {
            path: '/coupon-center/coupon-auto-list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponAutoAdd,
            },
            name: 'couponAutoAdd',
            meta: { label: '新建自动领取', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-auto-list', authKey: '#couponAutoList.add' },
          },
          // 编辑自动领取
          {
            path: '/coupon-center/coupon-auto-list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponAutoAdd,
            },
            name: 'couponAutoEdit',
            meta: { label: '编辑自动领取', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-auto-list', authKey: '#couponAutoList.modify' }
          },
          // 自动领取详情
          {
            path: '/coupon-center/coupon-auto-list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponAutoDetail,
            },
            name: 'couponAutoDetail',
            meta: { label: '自动领取详情', icon: 'el-icon-document', menuKeyPath: '/coupon-center/coupon-auto-list', authKey: 'couponAutoList' }
          },
        ]
      },
      // 优惠券流水
      {
        path: '/coupon-center/order-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.CouponOrderList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'couponOrderList',
        meta: { label: '优惠券流水', icon: 'el-icon-document', menuKeyPath: '/coupon-center/order-list' }
      },
      {
        path: '/coupon-center/order-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/coupon-center/order-list/detail',
        name: 'couponOrderListLayout',
        meta: { label: '优惠券流水', insidePageFrom: 'couponOrderList' },
        children: [
          // 订单详情
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.CouponOrderDetail,
            },
            name: 'couponOrderDetail',
            meta: { label: '优惠券流水详情', icon: 'el-icon-document', menuKeyPath: '/coupon-center/order-list', authKey: 'couponOrderList' }
          }
        ]
      }
    ]
  },
  /** ------------------------------ 受众人群管理 ------------------------------ */
  {
    path: '/accurate-engine',
    component: COM.Layout,
    redirect: '/accurate-engine/audience-list',
    name: 'market__engine',
    meta: { label: '营销引擎' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 受众人群管理列表
      {
        path: 'audience-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AudienceCrowdList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'audienceList',
        meta: { label: '受众人群管理', icon: 'el-icon-document', menuKeyPath: '/accurate-engine/audience-list' }
      },
      // 受众人群管理内页
      {
        path: '/accurate-engine/audience-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/accurate-engine/audience-list',
        name: 'audienceListLayout',
        meta: { label: '受众人群管理', insidePageFrom: 'audienceList' },
        children: [
          // 新增受众人群
          {
            path: '/accurate-engine/audience-list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AudienceCrowdAdd,
            },
            name: 'audienceCrowdAdd',
            meta: { label: '新建人群', icon: 'el-icon-document', menuKeyPath: '/accurate-engine/audience-list', authKey: '#audienceList.add' },
          },
          // 编辑受众人群
          {
            path: '/accurate-engine/audience-list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AudienceCrowdAdd,
            },
            name: 'audienceCrowdEdit',
            meta: { label: '编辑人群', icon: 'el-icon-document', menuKeyPath: '/accurate-engine/audience-list', authKey: '#audienceList.modify' },
          },
          // 人群详情
          {
            path: '/accurate-engine/audience-list/deteil',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AudienceCrowdDetail,
            },
            name: 'audienceCrowdDetail',
            meta: { label: '人群详情', icon: 'el-icon-document', menuKeyPath: '/accurate-engine/audience-list', authKey: 'audienceList' },
          },
          // 引用大数据人群
          {
            path: '/accurate-engine/audience-list/use-big-data',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AudienceUseBigData,
            },
            name: 'audienceUseBigData',
            meta: { label: '引用大数据人群', icon: 'el-icon-document', menuKeyPath: '/accurate-engine/audience-list', authKey: 'audienceList' },
          },
          // 大数据人群包详情
          {
            path: '/accurate-engine/audience-list/use-big-data/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AudienceUseBigDataDetail,
            },
            name: 'audienceUseBigDataDetail',
            meta: { label: '大数据人群详情', icon: 'el-icon-document', menuKeyPath: '/accurate-engine/audience-list', authKey: 'audienceList' },
          },
        ]
      },
      /** 精准投放管理 */
      // 精准投放管理列表
      {
        path: '/delivery-management/list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DeliveryManagementList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'deliveryManagementList',
        meta: { label: '精准投放管理', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list' }
      },
      // 受众人群管理内页
      {
        path: '/delivery-management/list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/delivery-management/list',
        name: 'deliveryManagementListLayout',
        meta: { label: '精准投放管理', insidePageFrom: 'deliveryManagementList' },
        children: [
          // 日历模式
          {
            path: '/delivery-management/calendar',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DeliveryManagementCalendar,
            },
            name: 'deliveryManagementCalendar',
            meta: { label: '日历模式', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list', authKey: 'deliveryManagementList' },
          },
          // 新建投放
          {
            path: '/delivery-management/list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DeliveryManagementAdd,
            },
            name: 'deliveryManagementAdd',
            meta: { label: '新建投放', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list', authKey: '#deliveryManagementList.add' },
          },
          // 编辑投放
          {
            path: '/delivery-management/list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DeliveryManagementAdd,
            },
            name: 'deliveryManagementEdit',
            meta: { label: '编辑投放', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list', authKey: '#deliveryManagementList.modify' },
          },
          // 投放详情
          {
            path: '/delivery-management/list/deteil',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.DeliveryManagementDetail,
            },
            name: 'deliveryManagementDetail',
            meta: { label: '投放详情', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list', authKey: 'deliveryManagementList' },
          },
          // 投放任务创建成功
          // {
          //   path: '/delivery-management/list/success',
          //   icon: 'el-icon-document',
          //   components: {
          //     bodyView: COM.DeliveryManagementSuccess,
          //   },
          //   name: 'deliveryManagementSuccess',
          //   meta: { label: '投放详情', icon: 'el-icon-document', menuKeyPath: '/delivery-management/list', authKey: 'deliveryManagementList' },
          // },
        ]
      },
      /** 效果报表管理 */
      // 投放效果总览
      {
        path: '/effectiveness-report/overview',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.EffectivenessReportOverview,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'effectivenessReportOverview',
        meta: { label: '投放效果总览', icon: 'el-icon-document', menuKeyPath: '/effectiveness-report/overview' }
      },
      // 投放效果总览内页
      {
        path: '/effectiveness-report/overview',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/effectiveness-report/overview',
        name: 'effectivenessReportOverviewLayout',
        meta: { label: '投放效果总览', insidePageFrom: 'effectivenessReportOverview' },
        children: [
          // 投放效果详情
          {
            path: '/effectiveness-report/overview/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.EffectivenessReportDetail,
            },
            name: 'effectivenessReportDetail',
            meta: { label: '投放效果详情', icon: 'el-icon-document', menuKeyPath: '/effectiveness-report/overview', authKey: 'effectivenessReportOverview' },
          },
        ]
      },
      // 自动化营销策略列表
      {
        path: '/automation-strategy/list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.AutomationStrategyList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'automationStrategyList',
        meta: { label: '自动化营销策略', icon: 'el-icon-document', menuKeyPath: '/automation-strategy/list' }
      },
      // 自动化营销策略内页
      {
        path: '/automation-strategy/list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/automation-strategy/list',
        name: 'automationStrategyListLayout',
        meta: { label: '自动化营销策略', insidePageFrom: 'automationStrategyList' },
        children: [
          // 新增
          {
            path: '/automation-strategy/list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AutomationStrategyAdd,
            },
            name: 'automationStrategyAdd',
            meta: { label: '新增策略', icon: 'el-icon-document', menuKeyPath: '/automation-strategy/list', authKey: 'automationStrategyList' },
          },
          // 编辑
          {
            path: '/automation-strategy/list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AutomationStrategyAdd,
            },
            name: 'automationStrategyEdit',
            meta: { label: '编辑策略', icon: 'el-icon-document', menuKeyPath: '/automation-strategy/list', authKey: 'automationStrategyList' },
          },
          // 详情
          {
            path: '/automation-strategy/list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AutomationStrategyDetail,
            },
            name: 'automationStrategyDetail',
            meta: { label: '详情', icon: 'el-icon-document', menuKeyPath: '/automation-strategy/list', authKey: 'automationStrategyList' },
          },
          // 查看数据
          {
            path: '/automation-strategy/list/view-data',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AutomationStrategyViewData,
            },
            name: 'automationStrategyViewData',
            meta: { label: '查看数据', icon: 'el-icon-document', menuKeyPath: '/automation-strategy/list', authKey: 'automationStrategyList' },
          }
        ]
      }
    ]
  },
  /** ------------------------------ 图文专题 ------------------------------ */
  {
    path: '/material-topic',
    component: COM.Layout,
    redirect: '/material-topic/list',
    name: 'market__materialTopic',
    meta: { label: '图文专题' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 图文专题列表
      {
        path: 'list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MaterialList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'materialList',
        meta: { label: '专题列表', icon: 'el-icon-document', menuKeyPath: '/material-topic/list' }
      },
      // 新增图文素材
      {
        path: '/material-topic/list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/material-topic/list/add',
        name: 'materialListLayout',
        meta: { label: '专题列表', insidePageFrom: 'materialList' },
        children: [
          // 新建图文素材
          {
            path: '/material-topic/list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MaterialAdd
            },
            name: 'materialAdd',
            meta: { label: '素材管理', icon: 'el-icon-document', menuKeyPath: '/material-topic/list', authKey: '#materialList.add' }
          },
          // 编辑图文素材
          {
            path: '/material-topic/list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MaterialAdd
            },
            name: 'materialEdit',
            meta: { label: '素材管理', icon: 'el-icon-document', menuKeyPath: '/material-topic/list', authKey: '#materialList.modify' }
          },
          // 图文效果
          {
            path: '/material-topic/list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MaterialDetail
            },
            name: 'materialDetail',
            meta: { label: '专题详情', icon: 'el-icon-document', menuKeyPath: '/material-topic/list', authKey: 'materialList' }
          }
        ]
      },
    ]
  },
];
export default marketingMgr;
